module.exports = __webpack_public_path__ + "static/media/Searching.49b5672f.svg";